import { render, staticRenderFns } from "./SopChangeControl.vue?vue&type=template&id=628bb40b&scoped=true&"
import script from "./SopChangeControl.vue?vue&type=script&lang=ts&"
export * from "./SopChangeControl.vue?vue&type=script&lang=ts&"
import style0 from "./SopChangeControl.vue?vue&type=style&index=0&id=628bb40b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "628bb40b",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VChip } from 'vuetify/lib/components/VChip';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VChip,VCol,VIcon,VRow,VSpacer})
